import { useState } from "react";
import styled from "styled-components";


import { GenericFieldProps } from "./common";
import InputField from "./InputField";

type PasswordFieldProps = GenericFieldProps & {
    required?: boolean;
};

const PasswordField = ({
    className,
    name,
    label,
    autoFocus,
    required,
}: PasswordFieldProps): JSX.Element => {
    const [isHidden, ] = useState(true);
    return (
        <div className={`position-relative ${className || ""}`}>
            <StyledInputField
                name={name}
                label={label}
                type={isHidden ? "password" : "text"}
                autoFocus={autoFocus}
                ariaLabelledBy="passwordPolicy"
                required={required}
            />
        </div>
    );
};


const StyledInputField = styled(InputField)`
    input::-ms-reveal {
        display: none;
    }
    margin-bottom: 20px;
`;

export default PasswordField;
